var forge = require("node-forge");
export const digestMessage = async (message: any) => {
	var md = forge.md.sha512.create();
	md.update(message);
	console.log(md.digest().toHex());
	console.log("hash", md.digest().toHex());
	return md.digest().toHex();
};
